<template>
  <div class="cdwritreason">
    <div class="reason between">
      <div class="reatext">
        <div class="reatit">为什么要选择律师代写合同？</div>
        <div class="reaitem">
          <span class="y"></span> <span>不适用：</span>
          <span>免费合同杂、乱、多，不知道是不是适合自己？</span>
        </div>
        <div class="reaitem">
          <span class="y"></span> <span>难度大：</span>
          <span>合同专业名词多，不知道怎么写才有效？</span>
        </div>
        <div class="reaitem">
          <span class="y"></span> <span>风险大：</span>
          <span>超过90%的免费合同，无针对自己的交易风险提示？</span>
        </div>
        <div class="reaitem">
          <span class="y"></span> <span>没经验：</span>
          <span>处于弱势地位，不知如何加大对自己的维护？</span>
        </div>
        <div class="reaitem">
          <span class="y"></span> <span>没律师：</span>
          <span>找不到称心的律师，支付大价钱，问题没解决？</span>
        </div>
        <div class="reaitem">
          <span class="y"></span> <span>没时间：</span>
          <span>急需合同洽谈业务却没时间起草，修订？</span>
        </div>
      </div>
      <div class="reaco">
        <img src="../../../assets//contmodeldet/htdxcenbtrg.png" alt="" />
      </div>
    </div>
    <div class="reason between reason1 mt30">
      <div class="reaco">
        <img src="../../../assets//contmodeldet/htdxcenbmlf.png" alt="" />
      </div>
      <div class="reatext">
        <div class="reatit">合同代写服务适合谁？</div>
        <div class="reaitem">
          <span class="y"></span> <span>事务繁忙：</span>
          <span
            >交易都要签合同，起草合同却没人手；事情重要且紧急，
            合同代写为您解忧。</span
          >
        </div>
        <div class="reaitem">
          <span class="y"></span> <span>时间宝贵：</span>
          <span
            >把专业的事交给专业的人，更快速为您拟定合同，节省 您的时间。</span
          >
        </div>
        <div class="reaitem">
          <span class="y"></span> <span>大宗买卖：</span>
          <span
            >您的交易涉及大额的钱、物，有很高的经济风险，需要
            专业律师为您把关。</span
          >
        </div>
        <div class="reaitem">
          <span class="y"></span> <span>权衡博弈：</span>
          <span
            >您与签约的一方是博弈的关系，急需专业律师为您争取 自身权益。</span
          >
        </div>
        <div class="reaitem">
          <span class="y"></span> <span>纠纷复杂：</span>
          <span
            >您的合同有3个及以上不同利益的人，专业律师才能为您
            理清思路，避免踩坑。</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.cdwritreason {
  width: 1200px;
  margin: 0 auto;
  padding: 50px 0;
  .reason {
    align-items: flex-start;
    .reatext {
      padding-top: 58px;
      .reatit {
        font-size: 24px;
        color: #333333;
        line-height: 24px;
      }
      .reaitem {
        font-size: 18px;
        color: #666666;
        line-height: 30px;
        margin-top: 24px;
        position: relative;
        padding-left: 45px;
        .y {
          position: absolute;
          top: 3px;
          left: 0px;
          &::before {
            content: "";
            position: absolute;
            top: 7px;
            left: 7px;
            width: 6px;
            height: 6px;
            background: #0465ea;
            border-radius: 50%;
          }
          &::after {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            width: 16px;
            height: 16px;
            border: 2px solid #0465ea;
            border-radius: 50%;
          }
        }
      }
    }
    &.reason1 {
      .reatext {
        padding-top: 40px;
        width: 612px;
        .reatit {
          margin-bottom: 36px;
        }
        .reaitem {
          line-height: 26px;
          margin-top: 18px;
        }
      }
    }
  }
}
</style>